import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';

const ReviewsButton = () => {
  return (
    <Link
      to="/reviews"
      className="fixed left-0 top-1/2 z-50 hidden -translate-y-1/2 flex-col items-center justify-center space-y-3 rounded-r-lg bg-black px-3 py-6 text-white shadow-lg transition-all duration-300 hover:bg-gray-800 hover:shadow-xl md:flex"
      aria-label="View Reviews"
    >
      <span 
        className="text-sm font-medium tracking-wide"
        style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
      >
        Reviews
      </span>
      <Star className="w-5 h-5 flex-shrink-0" />
    </Link>
  );
};

export default ReviewsButton;
